export const NotAvailableBadge = () => {
    return (
    <div className="w-full flex justify-center md:justify-start">
        <div className={"p-6 rounded-full font-extrabold text-center"} style={{background: '#E1E1E1'}}>⚠️ This prize is no longer available ⚠️ </div>
    </div>)
}